import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, FolderShared, Visibility } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import Badge from 'components/Badge/Badge';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 165 },
  { Header: 'Zonas', accessor: 'base_zone_descriptions', width: 220 },
  { Header: 'Mesas', accessor: 'base_bureau_descriptions', width: 220 },
  { Header: 'Cód. provedor', accessor: 'CardCode', width: 130 },
  { Header: 'provedor', accessor: 'CardName' },
  { Header: 'Marca', accessor: 'logi_mark_description', width: 200 },
  { Header: 'Categoría', accessor: 'logi_category_description', excelEnabled: false },
  { Header: 'Familia', accessor: 'logi_family_description', excelEnabled: false },
  { Header: 'Línea', accessor: 'logi_line_description', excelEnabled: false, width: 200 },
  { Header: 'Cantidad', accessor: 'quantity_min', excelEnabled: false, width: 120 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

export default WithApp(function DiscountRules(props) {
  const classes = useStyles();

  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const [discountRules, setDiscountRules] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listDiscountRules() {
    setDataLoading(true);
    let response = await wsGetAll('logi/discount-rule');
    setDataLoading(false);
    if (response.success) setDiscountRules(response.data);
  }

  useEffect(() => {
    listDiscountRules();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listDiscountRules} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_RULE_DISCOUNTS_STORE}
              component={
                <CardIcon color="primary">
                  <FolderShared style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de reglas de descuento {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Reglas de descuento"
              defaultWidth={2000}
              columns={columns}
              data={discountRules.map((rule, i) => {
                const noAssignedBag = (
                  <div className="actions-center">
                    <Badge color="info">No asignado</Badge>
                  </div>
                );
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_RULE_DISCOUNTS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="warning"
                          onClick={() => setOpen(rule)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_RULE_DISCOUNTS_SHOW}>
                        <Link to={`${rule.id}`}>
                          <Button justIcon round simple color="primary">
                            <Visibility />
                          </Button>
                        </Link>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_RULE_DISCOUNTS_DESTROY}>
                        <ButtonDelete
                          entity="logi/discount-rule"
                          id={rule.id}
                          reload={listDiscountRules}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  CardCode: rule.CardCode,
                  CardName: rule.CardName,
                  logi_category_description: rule.logi_category_description ?? noAssignedBag,
                  logi_family_description: rule.logi_family_description ?? noAssignedBag,
                  logi_line_description: rule.logi_line_description ?? noAssignedBag,
                  logi_mark_description: rule.logi_mark_description ?? noAssignedBag,
                  base_zone_descriptions: rule.base_zone_descriptions || noAssignedBag,
                  base_bureau_descriptions: rule.base_bureau_descriptions || noAssignedBag,
                  quantity_min: rule.quantity_min,
                  state: rule.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
